export enum ReferralTabEnum {
  OVERVIEW = "overview",
  RECORDS = "records",
  INSTRUCTIONS = "instructions",
}

export const ReferralEvent = {
  CLAIMED: "claimed",
};
